<template>
  <VueDateRangePicker
    :date-range="modelValue"
    opens="inline"
    :show-dropdowns="false"
    :ranges="null"
    :auto-apply="true"
    class="w-full"
    :min-date="minDate.toDate()"
    @update:model-value="v => $emit('update:modelValue', v)"
  />
</template>

<script>
import VueDateRangePicker from 'vue3-daterange-picker/src/components/DateRangePicker'
import dayjs from 'dayjs'

export default {
  components: { VueDateRangePicker },

  props: {
    modelValue: { type: [Object], required: true },
  },

  emits: ['update:modelValue'],

  data: () => ({
    minDate: dayjs(),
  }),
}
</script>

<style lang="scss" scoped>
:deep() {
  .form-control.reportrange-text { display: none; }
  .daterangepicker { margin-top: 0; border: 0; min-width: 0 !important; }
  .daterangepicker .drp-calendar.left { padding: 0; border: 0; }
  .daterangepicker .drp-calendar.right { display: none; }
  .daterangepicker .drp-calendar { width: 100%; max-width: none; }
  .daterangepicker.ltr .drp-calendar.left .calendar-table { padding: 0 !important; }
  .daterangepicker .calendar-table table { max-width: 21rem; margin: auto; }
  .daterangepicker .calendar-table th { @apply pb-3 text-base font-normal w-12 h-12; }
  .daterangepicker th.month { @apply text-xl font-medium; }
  .daterangepicker .calendar-table td { @apply w-auto h-auto text-base text-center w-12 h-12; }
  .daterangepicker td.in-range { @apply bg-gray-6 rounded-full; }
  .daterangepicker td.active, .daterangepicker td.active:hover { @apply rounded-full bg-gray-dark; }
  .daterangepicker td.start-date.end-date { @apply rounded-full; }
}
</style>
